import { render, staticRenderFns } from "./BsListTileContent.vue?vue&type=template&id=64603fff&scoped=true&"
import script from "./BsListTileContent.vue?vue&type=script&lang=js&"
export * from "./BsListTileContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64603fff",
  null
  
)

export default component.exports